import {classNames, Fragment, observer, pluralize, React, toJS, useMemo, utils} from '@api'
import {MenuDivider} from '@blueprintjs/core'
import {ContextMenuItem, ContextMenuItemProps} from '@modules/contextMenus'
import * as css from './CatalogItemPreviewMenuItem.css'
import {ICatalogFieldConfig, IDataMapConfig, LibraryItemConfig, nav, WorkspaceConfig} from '@stores'
import {DataMapper, ListPreviewCard} from 'centric-ui-components'
import {useStores} from '@design-board'

export type CatalogItemPreviewMenuItemProps = {
  showWorkspaceTitle?: boolean,
  menuLook?: boolean,
  data: any,
  index?: string,
  dataMap?: IDataMapConfig,
  library?: LibraryItemConfig,
  field?: ICatalogFieldConfig,
  onClick?: React.MouseEventHandler,
  workspace?: Partial<WorkspaceConfig>
}

export const CatalogItemPreviewMenuItem = observer<CatalogItemPreviewMenuItemProps & ContextMenuItemProps>(
  function CatalogItemPreviewMenuItem({className, showWorkspaceTitle, data, library, index, children, dataMap, field, workspace, menuLook, active, ...props}) {
    // console.log(toJS({workspace, data, index, dataMap, field}, {recurseEverything: true}))

    const stores = useStores(), {strings, catalog, dragDrop} = stores

    index = index ?? library?.index
    workspace = workspace ?? catalog.workspaceByIndex[index]
    dataMap = catalog.dataMapFor(dataMap ?? workspace?.dataMap)

    // console.log(dataMap)

    const ddHandler = useMemo(() => !data ? null : dragDrop.ddHandlerFor({index, data}), [index, data]),
      id = catalog.idFor(data),
      href = !id ? null : nav.urlForWorkspace({workspace, itemId: id, queryParams: {...catalog.queryParamsFor({detailLoc: 'sidebar'})}}, true)

    if (!data) {
      return <ContextMenuItem text={strings.noValue}/>
    }

    // console.log(toJS({dataMap, data, field: field?.field, index}))
    return (
      <Fragment>
        {showWorkspaceTitle && workspace && <MenuDivider title={pluralize(workspace.itemName, 1)} />}
      <ContextMenuItem
        icon={null}
        className={classNames(css.root, css.withListPreviewCard, className)}
        data-type='CatalogItemPreviewMenuItem'
        data-id={id}
        data-workspace={workspace?._id}
        data-active={active}
        data-field={field?.field}
        data-index={index}
        data-menu-look={menuLook !== false ? true : undefined}
        href={href}
        {...props}
        onClick={e => {
          // Prevent href triggering but still allow for right click -> Open in New Tab
          utils.eatMouseEvent(e)

          props.onClick && props.onClick(e)
        }}
        text={
          <div className={classNames(css.groupTitle)}>
            <DataMapper data={data} config={dataMap} nullValue={strings.emptyLabel} workspace={workspace}>
              <ListPreviewCard hideTooltips draggable={ddHandler.draggable}
                               stores={stores}
                               {...ddHandler.events} library={library}
                               workspace={workspace}
                               avatar={_.first(workspace?.itemName ?? 'U').toUpperCase()}
                               field={field}/>
            </DataMapper>
          </div>}
      >
        {children}
      </ContextMenuItem>
      </Fragment>
    )
  })




// WEBPACK FOOTER //
// ./src/modules/contextMenus/menus/internal/CatalogItemPreviewMenuItem.tsx